"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var getDeviceName = function getDeviceName(userAgent) {
  var osData = [[/Windows/, 'Windows'], [/Macintosh/, 'Mac OS'], [/Linux/, 'Linux'], [/Android/, 'Android'], [/iOS/, 'iOS']];
  var browserData = [[/Firefox/, 'Firefox'], [/OPR/, 'Opera'], [/Chrome/, 'Chrome'], [/Safari/, 'Safari'], [/Edge/, 'Edge'], [/(MSIE|Trident)/, 'Internet Explorer']];

  var matchData = function matchData(data) {
    var match = data.find(function (_ref) {
      var _ref2 = (0, _slicedToArray2["default"])(_ref, 1),
          regex = _ref2[0];

      return regex.test(userAgent);
    });
    return match ? match[1] : 'Unknown';
  };

  var deviceName = "".concat(matchData(browserData), " (").concat(matchData(osData), ")");
  return deviceName;
};

var _default = getDeviceName;
exports["default"] = _default;
//# sourceMappingURL=getDeviceName.js.map